import React, { useEffect, useState } from "react";
import { api, formatMoney } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Repeat } from "lucide-react";

const INTERVAL_LABEL = { month: "Monthly", year: "Yearly" };

export default function Subscriptions() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/subscriptions");
        setItems(data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  const isMerchant = user?.role === "merchant";

  return (
    <main data-testid="subscriptions-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="text-xs uppercase tracking-[0.3em] text-gold">{isMerchant ? "Recurring revenue" : "Your commitments"}</div>
      <h1 className="font-display text-5xl tracking-tighter mt-3">Subscriptions</h1>

      {loading ? (
        <div className="text-secondary-fg mt-10">Loading…</div>
      ) : items.length === 0 ? (
        <div className="border hairline p-16 text-center mt-12">
          <Repeat className="mx-auto text-gold mb-4" size={32} strokeWidth={1} />
          <div className="font-display text-2xl text-secondary-fg">No subscriptions yet</div>
          <div className="text-xs text-muted-fg mt-3">
            {isMerchant
              ? "Set up a recurring payment link to start accruing subscribers."
              : "Active subscriptions on y ℶα payment links appear here."}
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {items.map((s) => (
            <div key={s.subscription_id} data-testid={`sub-card-${s.subscription_id}`} className="lux-card p-7">
              <div className="text-xs uppercase tracking-widest text-muted-fg">{INTERVAL_LABEL[s.interval] || s.interval}</div>
              <div className="font-display text-4xl gold-text mt-3 tracking-tighter">{formatMoney(s.amount, s.currency)}</div>
              <div className="text-sm text-secondary-fg mt-4">
                {isMerchant ? s.payer_email : `Merchant: ${s.merchant_id}`}
              </div>
              <div className="mt-5 pt-4 border-t hairline text-xs text-muted-fg">
                <div>Status · <span className="text-gold uppercase tracking-widest">{s.status}</span></div>
                <div className="mt-1">Next billing · {s.next_billing_at ? new Date(s.next_billing_at).toLocaleDateString() : "—"}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
